import { Fragment } from "react";

import { useScrollReveal } from "../../../hooks/useScrollReveal";
import { useScrollProgress } from "../../../hooks/useScrollProgress";
import "./Quote01.css";

const QUOTE_PARTS = [
  { accent: true, text: "We curate a private network of creators," },
  {
    accent: false,
    text: "offering the protection and brand security needed to",
  },
  { accent: true, text: "confidently grow and protect what they've built." },
];

function buildWords() {
  const out = [];
  for (const part of QUOTE_PARTS) {
    for (const word of part.text.split(/\s+/).filter(Boolean)) {
      out.push({ word, accent: part.accent });
    }
  }
  return out;
}

const QUOTE_WORDS = buildWords();

/** Raw scroll progress (0–1) at which all words are visible; lower = completes earlier. */
const QUOTE_SCROLL_FINISH_AT = 0.75;

function Quote01() {
  const { ref, isVisible } = useScrollReveal();
  const progress = useScrollProgress(ref, QUOTE_SCROLL_FINISH_AT);

  const n = QUOTE_WORDS.length;
  const visibleCount = n === 0 ? 0 : Math.min(n, Math.floor(progress * n));

  return (
    <div ref={ref} className="Quote01 section" id="Quote01">
      <div className="container">
        <div
          className={`Quote01-box section-reveal ${isVisible ? "section--visible" : ""}`}
        >
          <h2>
            {QUOTE_WORDS.map((item, index) => (
              <Fragment key={index}>
                {index > 0 ? " " : null}
                <span
                  className={`Quote01-word ${item.accent ? "Quote01-word--accent" : ""} ${
                    index < visibleCount ? "Quote01-word--visible" : ""
                  }`}
                >
                  {item.word}
                </span>
              </Fragment>
            ))}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Quote01;
